import {iconUrl} from 'data/icon'
import {ensureStatuses} from '../type'

export const WAR = ensureStatuses({
	DEFIANCE: {
		id: 91,
		name: 'Defiance',
		icon: iconUrl(212551),
	},

	SURGING_TEMPEST: {
		id: 2677,
		name: 'Surging Tempest',
		icon: iconUrl(212561),
		duration: 60000,
	},

	EQUILIBRIUM: {
		id: 2681,
		name: 'Equilibrium',
		icon: iconUrl(212565),
		duration: 15000,
	},

	THRILL_OF_BATTLE: {
		id: 87,
		name: 'Thrill Of Battle',
		icon: iconUrl(210254),
		duration: 10000,
	},

	HOLMGANG: {
		id: 409,
		name: 'Holmgang',
		icon: iconUrl(210266),
		duration: 10000,
	},

	VENGEANCE: {
		id: 89,
		name: 'Vengeance',
		icon: iconUrl(210256),
		duration: 15000,
	},

	BLOODWHETTING: {
		id: 2678,
		name: 'Bloodwhetting',
		icon: iconUrl(212562),
		duration: 8000,
	},

	STEM_THE_FLOW: {
		id: 2679,
		name: 'Stem the Flow',
		icon: iconUrl(212563),
		duration: 4000,
	},

	STEM_THE_TIDE: {
		id: 2680,
		name: 'Stem the Tide',
		icon: iconUrl(212564),
		duration: 20000,
	},

	NASCENT_FLASH: {
		id: 1857,
		name: 'Nascent Flash',
		icon: iconUrl(212558),
		duration: 8000,
	},

	NASCENT_GLINT: {
		id: 1858,
		name: 'Nascent Glint',
		icon: iconUrl(212559),
		duration: 8000,
	},

	SHAKE_IT_OFF: {
		id: 1457,
		name: 'Shake It Off',
		icon: iconUrl(212557),
		duration: 30000,
	},

	SHAKE_IT_OFF_OVER_TIME: {
		id: 2108,
		name: 'Shake It Off (Over Time)',
		icon: iconUrl(212567),
		duration: 15000,
	},

	NASCENT_CHAOS: {
		id: 1897,
		name: 'Nascent Chaos',
		icon: iconUrl(212560),
		duration: 30000,
	},

	INNER_RELEASE: {
		id: 1177,
		name: 'Inner Release',
		icon: iconUrl(217247),
		duration: 15000,
		stacksApplied: 3,
	},

	PRIMAL_REND_READY: {
		id: 2624,
		name: 'Primal Rend Ready',
		icon: iconUrl(212566),
		duration: 30000,
	},

	PRIMAL_RUINATION_READY: {
		id: 3834,
		name: 'Primal Ruination Ready',
		icon: iconUrl(212569),
		duration: 30000,
	},

	BURGEONING_FURY: {
		id: 3833,
		name: 'Burgeoning Fury',
		icon: iconUrl(218147),
		duration: 30000,
	},

	WRATHFUL: {
		id: 3901,
		name: 'Wrathful',
		icon: iconUrl(212571),
		duration: 30000,
	},

	DAMNATION: {
		id: 3832,
		name: 'Damnation',
		icon: iconUrl(212568),
		duration: 15000,
	},

	PRIMEVAL_IMPULSE: {
		id: 3900,
		name: 'Primeval Impulse',
		icon: iconUrl(212570),
		duration: 15000,
	},

})
